// @ts-nocheck — deep generics vs generated GraphQL schema types = type-narrowing noise (not runtime bugs); proper generic rewrite is a follow-up (issue #11).
import type {
   query_rootRequest,
   query_root,
   mutation_rootRequest,
   mutation_root,
   subscription_rootRequest,
   subscription_root
} from './generated/schema.js';
import type { MutationInput, QueryArguments, QueryOptions, SubscriptionArguments, SubscriptionInput } from './graphdb_handlers.js';

import { graph_operations } from './graphdb_handlers.js';
import { auth_sdk } from './auth_sdk.js';
import { generateSubscriptionOp } from './generated/index.js';
import { createClient } from 'graphql-ws';
import { create_map_state, type MapStateReturn } from './create_map_state.svelte.js';
import { WS_ENDPOINT } from './index.js';

type SecondElement<Tuple> = Tuple extends [any, infer Second] ? Second : never;
type FirstElement<Tuple> = Tuple extends [infer First, ...any[]] ? First : never;
type ElementOf<T> = T extends (infer E)[] ? E : never;
type IndexKeys<T> = { last_updated_index: keyof T, main_index: keyof T }

type CreateDbMapStateInput<
   T extends keyof query_rootRequest,
   K extends keyof query_root,
   S extends keyof query_rootRequest,
   SK extends keyof query_root,
   C extends keyof mutation_rootRequest,
   CK extends keyof mutation_root,
   U extends keyof mutation_rootRequest,
   UK extends keyof mutation_root,
   D extends keyof mutation_rootRequest,
   SUB extends keyof subscription_rootRequest,
   SUBK extends keyof subscription_root,
> = {
   many_q: T | K;
   sub_q?: SUB | SUBK;
   single_q: S | SK;
   create_q?: C | CK;
   update_q?: U | UK;
   delete_q?: D;
   return_fields: QueryArguments<T>;
   options?: QueryOptions<T>;
   options_fn?: (state: MapStateReturn<ElementOf<query_root[K]>>, latest_update: string) => Promise<QueryOptions<T> | null> | QueryOptions<T> | null;
   auto_populate?: boolean;
   post_populate_fn?: (values: ElementOf<query_root[K]>[]) => void;
   db_name?: string;
   auto_prune?: boolean;
   state_name: string;
   derive_value_fn?: (value: ElementOf<query_root[K]>) => ElementOf<query_root[K]>;
   // derive_value_single_fn?: (value: ElementOf<query_root[K]>) => ElementOf<query_root[K]>;
} & (
      {
         incremental: true;
         auto_subscribe?: true;
         index_keys: IndexKeys<ElementOf<query_root[K]>>,
      } | {
         incremental?: false;
         auto_subscribe?: false;
         index_keys?: IndexKeys<ElementOf<query_root[K]>>,
      }
   );



const subscriptions_map = new Map<string, (() => void)>()
const reset_states_map = new Map<string, (() => void)>()
const auto_populate_map = new Map<string, (() => Promise<any>)>()

export function unsubscribe_all_states() {
   subscriptions_map.forEach((unsub) => unsub?.())
}

export function reset_all_states() {
   reset_states_map.forEach((reset) => reset?.())
}

export function populate_all_auto_populate_states() {
   auto_populate_map.forEach((populate) => populate?.())
}


export type DbMapState = ReturnType<typeof create_db_map_state>

export function create_db_map_state<
   T extends keyof query_rootRequest,
   K extends keyof query_root,
   S extends keyof query_rootRequest,
   SK extends keyof query_root,
   C extends keyof mutation_rootRequest,
   CK extends keyof mutation_root,
   U extends keyof mutation_rootRequest,
   UK extends keyof mutation_root,
   D extends keyof mutation_rootRequest,
   SUB extends keyof subscription_rootRequest,
   SUBK extends keyof subscription_root,
>({
   state_name,
   many_q,
   sub_q,
   single_q,
   incremental,
   create_q,
   update_q,
   delete_q,
   derive_value_fn,
   post_populate_fn,
   return_fields,
   index_keys,
   options,
   options_fn,
   auto_prune,
   auto_populate = false,
   auto_subscribe = false,
   db_name,
}: CreateDbMapStateInput<T, K, S, SK, C, CK, U, UK, D, SUB, SUBK>) {
   type StoreType = ElementOf<query_root[K]>;

   const current_map_state = create_map_state<StoreType>({
      state_name,
      incremental,
      db_name,
      fetch_one_fn: fetch_one as any,
      derive_value_fn,
      index_keys,
      populate_fn: fetch_many,
   });


   async function fetch_one(
      id: string,
      new_return_fields?: QueryArguments<S>
   ): Promise<StoreType | null> {
      const one = await graph_operations.operations.read_one(single_q, {
         id,
         return_fields: new_return_fields ?? (return_fields as unknown as QueryArguments<S>)
      }) as StoreType | null

      if (!one) return null;
      current_map_state.update_one(one)
      return one
   }



   async function fetch_many(fn_arguments?: {
      options: QueryOptions<T>;
      new_return_fields?: QueryArguments<T>;
      no_options?: boolean;
   }): Promise<StoreType[] | null> {
      try {

         const read_options = fn_arguments?.options
            ? fn_arguments?.options
            : fn_arguments?.no_options ? undefined
               : options_fn
                  ? await options_fn(current_map_state, await current_map_state.get_state_latest_sync())
                  : options ? options :
                     incremental ? { where: { [index_keys.last_updated_index]: { _gt: await current_map_state.get_state_latest_sync() } } }
                        : undefined

         // console.log('read_many options: ', read_options)
         // if ((options || fn_arguments?.options || options_fn) && !read_options) return null;

         const many = await graph_operations.operations.read_many(many_q, {
            return_fields: fn_arguments?.new_return_fields ?? return_fields,
            options: read_options ?? undefined
         }) as StoreType[] | null

         if (!many) return null;

         if (fn_arguments?.new_return_fields) {
            for (const updated_item of many) {
               const stored_item = await current_map_state.indexeddb_crud.get_one(updated_item.id)
               if (!stored_item) current_map_state.update_one(updated_item)
               else current_map_state.update_one({ ...stored_item, ...updated_item })
            }
         }

         else current_map_state.update_many(many)
         return many
      } catch (error) {
         console.error('error at create_db_map_state fetch_many:', { state_name, error })
         return null
      }
   }

   async function update_one(options: {
      input: MutationInput<U | UK>;
   }): Promise<mutation_root[UK] | null> {
      if (!update_q) return null;
      console.log({ update_q, options })
      const response = await graph_operations.operations.mutate(update_q, {
         input: options.input,
         return_fields: return_fields as unknown as SecondElement<NonNullable<mutation_rootRequest[U]>>
      }) as Partial<StoreType>;

      if (!response?.id) return null;

      current_map_state.update_one(response)
      return derive_value_fn ? derive_value_fn(response) as mutation_root[CK] : response as mutation_root[CK]
   }

   async function create_one(options: {
      input: MutationInput<C | CK>;
   }): Promise<mutation_root[CK] | null> {
      if (!create_q) return null;
      const response = await graph_operations.operations.mutate(create_q, {
         input: options.input,
         return_fields: return_fields as unknown as SecondElement<NonNullable<mutation_rootRequest[C | CK]>>
      }) as Partial<StoreType>;

      if (!response?.id) return null;
      current_map_state.update_one(response)

      return derive_value_fn ? derive_value_fn(response) : response as mutation_root[CK]
   }

   async function delete_one(id: string): Promise<boolean> {
      if (!delete_q) return false;
      const delete_id = await graph_operations.operations.delete_one(delete_q, id);
      if (!delete_id) return false;

      current_map_state.remove_one(id)
      return true;
   }

   async function soft_delete_one(id: string): Promise<boolean> {
      if (!update_q) return false;

      const input = {
         pk_columns: { id },
         _set: { is_deleted: true }
      };

      const soft_delete_op = await graph_operations.operations.mutate(update_q, {
         input: input as any,
         return_fields: { id: true } as any
      }) as { id: string } | null;

      if (!soft_delete_op?.id) return false;

      current_map_state.remove_one(soft_delete_op.id)

      return true;
   }

   function subscribe(
      sub_options?: { input?: SubscriptionInput<SUB>; return_fields?: SubscriptionArguments<SUB>, no_id?: boolean, manual_update?: boolean },
      callback?: (value: subscription_root[SUBK]) => any
   ): () => void {
      try {
         if (!sub_q) throw new Error('no subscription query for: ' + state_name)
         const actual_return_fields = sub_options?.return_fields || return_fields
         const combined_query_options = { ...sub_options?.input, ...options }

         const { query, variables } = generateSubscriptionOp({
            [sub_q]: [combined_query_options, { ...actual_return_fields, id: sub_options?.no_id ? undefined : true }]
         });

         unsubscribe()

         const wsClient = createClient({
            url: WS_ENDPOINT,
            shouldRetry: () => true,
            retryAttempts: Infinity,
            retryWait: (attempts) => new Promise(resolve => setTimeout(resolve, Math.min(1000 * 2 ** attempts, 30000))),
            connectionParams: async () => ({
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${await auth_sdk.get_access_token()}`
               }
            }),
            on: {
               connected: (socket: any) => {
                  // Heartbeat setup
                  let pong_timeout: NodeJS.Timeout;
                  const heartbeat_interval = setInterval(() => {
                     socket.send(JSON.stringify({ type: 'ping' }));

                     // Expect pong within 7 seconds
                     pong_timeout = setTimeout(() => {
                        console.error('############## pong_timeout, closing socket #############')
                        socket.close(4408, 'Pong timeout');
                     }, 7000);
                  }, 30000); // Ping every 30 seconds

                  // Handle pong responses
                  function pong_handler(event: MessageEvent) {
                     try {
                        const msg = JSON.parse(event.data);
                        if (msg.type === 'pong') clearTimeout(pong_timeout);
                     } catch { console.error('error at pong_handler', event?.data) }
                  };

                  socket.addEventListener('message', pong_handler);

                  // Cleanup on disconnect
                  socket.addEventListener('close', () => {
                     clearInterval(heartbeat_interval);
                     clearTimeout(pong_timeout);
                     socket.removeEventListener('message', pong_handler);
                  });
               }
            }


         });
         // console.log('SUB query: ', query, variables)
         const subscription = wsClient.subscribe(
            {
               query,
               variables,
            },
            {
               next: async ({ data }) => {
                  if (!data?.[sub_q]) return
                  const payload = Object.values(data[sub_q]) as subscription_root[SUBK]
                  console.log(`${state_name} subscription payload: `, { payload })
                  if (!Array.isArray(payload)) return


                  if (callback) callback(payload)
                  if (sub_options?.manual_update) return

                  current_map_state.update_many(payload as StoreType[])
               },
               error: (err) => console.error(`${state_name} subscription error: `, err),
               complete: () => console.log(`${state_name} unsubscribed`)
            }
         );

         if (subscription) subscriptions_map.set(`${state_name}_${sub_q}`, () => {
            subscription()
            wsClient.terminate()
         })

         return unsubscribe

      } catch (error) {
         console.error('error at mutate: ', error)
         unsubscribe()
         return () => { }
      }
   }

   function unsubscribe() {
      const subscription = subscriptions_map.get(`${state_name}_${sub_q}`)
      if (subscription) subscription()
      subscriptions_map.delete(`${state_name}_${sub_q}`)
   }

   function update_local_one_using_old(id: string, update_fn: (old_value: StoreType) => StoreType) {
      if (!id || !update_fn) return false

      const item = current_map_state.map.get(id)
      if (!item) return false
      const new_value = update_fn(item)
      current_map_state.update_one(new_value)
   }

   async function auto_subscribe_handler() {
      setTimeout(async () => {

         const latest_updated_date = await current_map_state.get_state_latest_sync()

         subscribe({
            input: { batch_size: 10, cursor: [{ initial_value: { [index_keys!.last_updated_index]: latest_updated_date } }] },
            return_fields: return_fields as any
         });
      }, 3000)

   }


   async function populate_fn() {
      const values = await current_map_state.populate_fn()
      if (values && post_populate_fn) post_populate_fn(values as StoreType[]);
      // if (auto_prune) auto_prune_handler()
      return values
   }

   async function reset() {
      current_map_state.reset()
      unsubscribe()
   }

   async function auto_prune_handler() {
      try {
         await new Promise(resolve => setTimeout(resolve, 3000))
         const stored_values = await current_map_state.filter_async((_) => true, ['id']);
         if (!stored_values.length) return
         const stored_ids = stored_values.map(item => item.id)

         const has_is_deleted_field = Object.keys(return_fields).some((key) => key === 'is_deleted')
         const auto_prune_return_fields = has_is_deleted_field ? { id: true, is_deleted: true } : { id: true }
         // console.log({ auto_prune_return_fields, has_is_deleted_field, }, Object.keys(return_fields))

         const db_values = await graph_operations.operations.read_many(many_q, {
            return_fields: auto_prune_return_fields as any,
            options: { where: { id: { _in: stored_ids } } } as any
         }) as StoreType[] | null

         if (!db_values) return null;
         const db_values_ids = db_values.map(item => item.id)
         const deleted_ids = has_is_deleted_field ? db_values.filter(item => (item as any).is_deleted).map(item => item.id) : []
         if (deleted_ids.length) await current_map_state.remove_many(deleted_ids)
         console.log({ deleted_ids })

         let promises: Promise<any>[] = []
         for (const stored_id of stored_ids) {
            if (!db_values_ids.includes(stored_id)) {
               console.log('removing: ', stored_id)
               promises.push(current_map_state.remove_one(stored_id))
            }
         }
         await Promise.all(promises)
         return true
      } catch (error) {
         console.error('error at auto_prune_handler', error)
         return false
      }

   }

   async function full_resync() {

      const new_values = await fetch_many({ no_options: true, options: undefined as any })
      if (!new_values) return false

      await current_map_state.resync_state()
      await current_map_state.update_many(new_values)
      current_map_state.paginated_state.refresh()
      return true
   }

   reset_states_map.set(`${state_name}`, reset)

   if (typeof window !== 'undefined') {
      if (auto_populate) {
         auto_populate_map.set(state_name, populate_fn)
         auth_sdk.on_auth(state_name + 'auto_populate', async () => {

            await current_map_state.populate_fn()
            if (auto_subscribe) auto_subscribe_handler()
            if (auto_prune) setTimeout(auto_prune_handler, 1500)
         });
      } else if (auto_subscribe) auth_sdk.on_auth(state_name + 'auto_subscribe', auto_subscribe_handler);

      if (!auto_populate && auto_prune) auth_sdk.on_auth(state_name + 'auto_prune', auto_prune_handler);
   }
   return {
      ...current_map_state,
      populate: populate_fn,
      state_name,
      create_one,
      fetch_one,
      fetch_many,
      delete_one,
      full_resync,
      update_one,
      soft_delete_one,
      reset,
      get values() {
         return Array.from(current_map_state.map.values())
      },
      update_local_one: current_map_state.update_one,
      update_local_one_using_old,
      update_local_many: current_map_state.update_many,
      subscribe,
      unsubscribe,
      utils: {
         return_fields,
      },
      get map() {
         return current_map_state.map;
      },
   };
}
